export * from "./ChallengeMedium";
